module.exports = __webpack_public_path__ + "img/main01.1941ca45.jpg";